module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-120x120-7de6ae8eb23de29123047a91a65140d4.png";